// src/components/ValuationStatusLine.jsx
// Ligne d'état d'une valorisation : statut (indicative / validée par un expert), date, badge « ancienne »,
// et mention de prudence. À placer à côté de toute fourchette ou valeur d'une œuvre.
import React from "react";
import { useTranslation } from "react-i18next";
import {
  valuationDate, isStaleValuation, valuationStatus, valuationText, formatValuationDate,
} from "../utils/valuationDisclosure";

export default function ValuationStatusLine({ artwork, className = "", compact = false }) {
  const { i18n } = useTranslation();
  const lang = String(i18n.resolvedLanguage || i18n.language || "fr").slice(0, 2);
  const tx = valuationText(lang);
  const date = valuationDate(artwork);
  const status = valuationStatus(artwork);
  const stale = isStaleValuation(date);

  if (compact) {
    // Version listes/tableaux : date + badge « ancienne » (+ pastille seulement si validée par un expert)
    return (
      <div className={`flex flex-wrap items-center gap-1.5 text-[11px] text-gray-500 ${className}`}>
        <span>{date ? `${tx.estimatedOn} ${formatValuationDate(date, lang)}` : tx.noDate}</span>
        {status === "expert" && <span className="rounded-full bg-emerald-100 px-1.5 py-0.5 font-medium text-emerald-700">{tx.expert}</span>}
        {stale && <span className="rounded-full bg-amber-100 px-1.5 py-0.5 font-medium text-amber-700">{tx.stale}</span>}
      </div>
    );
  }

  return (
    <div className={`flex flex-wrap items-center gap-2 text-xs ${className}`}>
      <span className={`rounded-full px-2 py-0.5 font-medium ${status === "expert" ? "bg-emerald-100 text-emerald-700" : "bg-gray-200 text-gray-700"}`}>
        {tx[status]}
      </span>
      <span className="text-gray-500">
        {date ? `${tx.estimatedOn} ${formatValuationDate(date, lang)}` : tx.noDate}
      </span>
      {stale && <span className="rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-700">{tx.stale}</span>}
    </div>
  );
}
